import React, { useEffect, useRef } from "react";
import "../styles/OurTeam.css";

const teamMembers = [
  {
    id: 1,
    name: "Dr. Ramesh Kumar",
    qualification: "MBBS, MD (Pathology)",
    role: "Consultant Pathologist",
    experience: "Experience: 15+ Years",
    img: "https://randomuser.me/api/portraits/men/52.jpg",
  },
  {
    id: 2,
    name: "Dr. Priya Lakshmi",
    qualification: "MBBS, MD (Microbiology)",
    role: "Consultant Microbiologist",
    experience: "Experience: 12+ Years",
    img: "https://randomuser.me/api/portraits/women/44.jpg",
  },
  {
    id: 3,
    name: "Dr. Arvind Raja",
    qualification: "M.Sc., Ph.D (Biochemistry)",
    role: "Consultant Biochemist",
    experience: "Experience: 10+ Years",
    img: "https://randomuser.me/api/portraits/men/34.jpg",
  },
  {
    id: 4,
    name: "Ms. Kavitha S.",
    qualification: "M.Sc., Genetic Counseling",
    role: "Genetic Counselor",
    experience: "Experience: 8+ Years",
    img: "https://randomuser.me/api/portraits/women/68.jpg",
  },
];

const OurTeam = () => {
  const gridRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("ot-card-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    const cards = gridRef.current?.querySelectorAll(".ot-card");
    cards?.forEach((card, i) => {
      card.style.setProperty("--ot-delay", `${i * 0.13}s`);
      observer.observe(card);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="ot-section">
      <div className="ot-container">
        <h2 className="ot-heading">OUR TEAM</h2>
        <div className="ot-grid" ref={gridRef}>
          {teamMembers.map((member) => (
            <div className="ot-card" key={member.id}>
              <div className="ot-img-wrap">
                <img
                  src={member.img}
                  alt={member.name}
                  loading="lazy"
                  className="ot-img"
                  onError={(e) => {
                    e.target.src =
                      "https://via.placeholder.com/100x130?text=Dr.";
                  }}
                />
              </div>
              <div className="ot-info">
                <h3 className="ot-name">{member.name}</h3>
                <p className="ot-qualification">{member.qualification}</p>
                <p className="ot-role">{member.role}</p>
                <p className="ot-experience">{member.experience}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurTeam;